// extracted by mini-css-extract-plugin
module.exports = {"bottom-toolbar":"Pagination_bottom-toolbar__3wG1f","badge":"Pagination_badge__2BjSK","active":"Pagination_active__hJFeq"};